import { concatUrl } from "./common";
import { rokidAccountBaseUrl } from "@rokid/host";
import type { IConfig, IResult } from "./request.d";

function getCookieItem(sKey) {
  return (
    decodeURIComponent(
      document.cookie.replace(
        new RegExp(
          "(?:(?:^|.*;)\\s*" +
            encodeURIComponent(sKey).replace(/[-.+*]/g, "\\$&") +
            "\\s*\\=\\s*([^;]*).*$)|^.*$",
        ),
        "$1",
      ),
    ) || null
  );
}

/**
 * @type TParams 传入参数类型
 * @type TData 函数返回类型
 */
export async function request<TParams = Record<string, any>, TResult = any>(
  config: IConfig<TParams>
): Promise<IResult<TResult>> {
  const defaultConfig: IConfig<TParams> = {
    method: "get",
    credentials: "include",
    postWithQuery: false,
    noFilter: false,
  };
  let headers = {
    "Content-Type": "application/json",
    ...(config.headers || {}),
    access_token:''
  };
  if (config.needToken) {
    headers.access_token = getCookieItem('ROKID_ACCOUNT_SESSION') || ''
  }
  const newConfig: IConfig<TParams> = Object.assign({}, defaultConfig, config);
  newConfig.headers = headers;
  const { method = "get", params, data, postWithQuery } = newConfig;
  let { url } = newConfig;
  if (
    method.toLowerCase() === "get" ||
    method.toLowerCase() === "getfile" ||
    postWithQuery
  ) {
    url =
      params && Object.keys(params).length > 0
        ? `${url}?${concatUrl(params)}`
        : url;
  }
  if (method.toLowerCase() === "post" || method.toLowerCase() === "put") {
    newConfig.body = JSON.stringify(data);
  }
  if (method.toLowerCase() === "getfile") {
    newConfig.method = "get";
  }
  if (method.toLowerCase() === "postform") {
    newConfig.method = "post";
    newConfig.body = data as FormData;
    newConfig.headers = config.headers || {};
  }
  if (!url) {
    return Promise.reject("未传入URL，请检查传递参数！");
  }
  return fetch(url, newConfig)
    .then(
      (response) => {
        if (method.toLowerCase() === "getfile") {
          let filename = "";
          const contentDisposition = response.headers.get(
            "Content-Disposition"
          );
          // 跨域情况下获取不到文件名
          if (contentDisposition) {
            const filenamePart = contentDisposition
              ?.split(";")
              .find((i) => i.includes("filename"));
            const filenameStr = filenamePart?.split("=")[1] || "";
            const [name, ext] = filenameStr.split(".");
            filename = decodeURIComponent(name) + "." + ext;
          }
          return response.blob().then((blob) => ({ filename, blob }));
        }
        return response.json();
      },
      (ex) => {
        throw new Error(`请求服务器出错:${url} ${ex.message}`);
      }
    )
    .then(
      (res) => {
        const { code, status } = res;
        if (code == 1001 || code == 9001 || code == 8001 || status == 401) {
          window.location.href = `${rokidAccountBaseUrl}/login?redirect=${encodeURI(
            window.location.href
          )}`;
        }
        return res;
      },
      (ex) => {
        throw new Error(`解析JSON字符串出错:${url} ${ex.message}`);
      }
    );
}

export default request;
